export default "__VITE_ASSET__CTvhUkDf__"